export const ACCOUNT_DETAIL_TABS = [
  { id: "info", label: "Info" },
  { id: "devices", label: "Devices" },
  { id: "permissions", label: "Permissions" },
  { id: "asset-types", label: "Asset types" },
  { id: "assets", label: "Asset" },
  { id: "fms", label: "FMS" },
  { id: "service-account", label: "Service account" },
  { id: "icp", label: "ICP" },
];
